// extracted by mini-css-extract-plugin
module.exports = {"WrapperActionBoxByTypeProduct":"ActionBoxByTypeProduct_WrapperActionBoxByTypeProduct__B_QPQ","Container":"ActionBoxByTypeProduct_Container__fF9yJ"};